import { useMemo } from 'react';
import { AppBaseDto } from '../../api/graph.types';
import { CredentialInfo } from './types';
import useExpiryClassification from './useExpiryClassification';
import useIsVisibleCredential from './useIsVisibleCredential';

export default function useCredentialInfo(app: AppBaseDto, isSaml: boolean): CredentialInfo {
  const { isAboutToExpire, isExpired } = useExpiryClassification();
  const isVisible = useIsVisibleCredential();

  const certificates = useMemo(() => {
    return app.keyCredentials.filter((credential) => isVisible(credential, app.id));
  }, [app, isVisible]);

  const secrets = useMemo(() => {
    return app.passwordCredentials.filter((credential) => isVisible(credential, app.id));
  }, [app, isVisible]);

  const expiringCertificates = useMemo(() => {
    return certificates.filter((certificate) =>
      isAboutToExpire(certificate.endDateTime ? new Date(certificate.endDateTime) : undefined, isSaml)
    );
  }, [certificates, isSaml, isAboutToExpire]);

  const expiringSecrets = useMemo(() => {
    return secrets.filter((secret) =>
      isAboutToExpire(secret.endDateTime ? new Date(secret.endDateTime) : undefined, isSaml)
    );
  }, [secrets, isSaml, isAboutToExpire]);

  const expiredCertificates = useMemo(() => {
    return certificates.filter((certificate) =>
      isExpired(certificate.endDateTime ? new Date(certificate.endDateTime) : undefined)
    );
  }, [certificates, isExpired]);

  const expiredSecrets = useMemo(() => {
    return secrets.filter((secret) => isExpired(secret.endDateTime ? new Date(secret.endDateTime) : undefined));
  }, [secrets, isExpired]);

  return {
    certificates,
    secrets,
    expiringCertificates,
    expiringSecrets,
    expiredCertificates,
    expiredSecrets,
  };
}
